var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lc-color-picker-cancel",attrs:{"type":"button"},on:{"click":_vm.action}},[_vm._v("\n    Cancel\n")])}
var staticRenderFns = []

export { render, staticRenderFns }